import React from 'react';
import {Grid} from "@mui/material";
// import {Button, Grid} from "@mui/material";
import ContentContainer from "../../components/ContentContainer";
import ProjectRecord from "../../components/ProjectRecord";
import engagementMap from '../../assets/images/engagementMap.png'
import goHam from '../Work/go_ham/go_ham_cover_bg.png'
import standUpReminder from '../Work/stand_up_reminder/stand-up-cover-bg.png'
import bookCover1 from '../Work/book_cover/book_cover1_thumb.png'
import './work.sass'
// import {Link} from "react-router-dom";

function Work({cursor}) {
    return (
        <ContentContainer header={'Featured Work'}>
            <Grid container spacing={'4rem'}>
                <Grid item xs={12}>
                    <ProjectRecord
                        to={'/work/GO-HAM'}
                        title={'GO HAM!'}
                        subtitle={'Re-establishing the Columbia community during COVID-19 through exercise'}
                        desc={'Exercising app with emphasis on spontaneous human interaction through gamification. ' +
                        'Helps motivate and keep students in a routine to exercise in a limited space with friends.'}
                        img={goHam}
                        imgAlt={'smart phone app design of go ham'}
                        bgColor={'linear-gradient(127.67deg, rgba(17, 141, 255, 0.2) 60.94%, rgba(217, 242, 249, 0.2) 76.79%, rgba(255, 255, 255, 0.0252632) 92.97%), #D5FFCB'}
                        cursor={cursor}
                    />
                </Grid>

                <Grid item xs={12}>
                    <ProjectRecord
                        to={'/work/EngagementMap'}
                        title={'EngagementMap'}
                        subtitle={'A real-time, location-based, collective, and anonymous feedback system in the classroom'}
                        desc={'Provides instructors with a glanceable spatial visualization of the classroom to help them understand ' +
                        'how students are feeling.'}
                        img={engagementMap}
                        imgAlt={'smart phone app design of engagement map'}
                        bgColor={'linear-gradient(127.67deg, rgba(253, 131, 255, 0.2) 60.94%, rgba(255, 139, 139, 0) 76.79%, rgba(255, 255, 255, 0.0252632) 92.97%), #ECF5FF'}
                        cursor={cursor}
                    />
                </Grid>

                <Grid item xs={12}>
                    <ProjectRecord
                        to={'/work/Alexa-Stand-Up-Reminder'}
                        color={'dark'}
                        title={'Alexa Stand Up Reminder'}
                        subtitle={'Sitting for a long time has health concerns and we wanted to help you in a natural way'}
                        desc={'Reminds you to stand up every 45 minutes and take a break for 5 minutes. During the break, it suggests  fun and relaxing activities!'}
                        img={standUpReminder}
                        imgAlt={'logo with alexa'}
                        bgColor={'linear-gradient(114.74deg, rgba(0, 114, 255, 0.5) 56.88%, rgba(167, 125, 255, 0.265652) 97.5%, rgba(255, 255, 255, 0.0631579) 113.08%), #FF583B'}
                        cursor={cursor}
                    />
                </Grid>

                <Grid item xs={12}>
                    <ProjectRecord
                        to={'/work/book-covers'}
                        title={'Published Book Covers'}
                        subtitle={'I designed 2 book covers that were published in Japan'}
                        img={bookCover1}
                        imgAlt={'logo of the book cover i designed about inclusive education'}
                        bgColor={'linear-gradient(127.67deg, rgba(17, 141, 255, 0.3) 60.94%, rgba(217, 242, 249, 0.3) 76.79%, rgba(255, 255, 255, 0.0378947) 92.97%), #F3FFF0'}
                        cursor={cursor}
                    />
                </Grid>

                {/*<Grid item xs={12} className={'featured_work__more_btn'}>*/}
                {/*    <Link to={'/work'}>*/}
                {/*        <Button*/}
                {/*            className={'about__btn about__more_btn'}*/}
                {/*            variant={'outlined'}*/}
                {/*            disableElevation*/}
                {/*        >*/}
                {/*            More Work*/}
                {/*        </Button>*/}
                {/*    </Link>*/}
                {/*</Grid>*/}

            </Grid>
        </ContentContainer>
    );
}

export default Work;